// src/pages/RecipePage.jsx
import React, { useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import recipes from "../components/receipe";
import "../pages/Products.css";
import "./RecipePage.css";
import NavBar from "../components/Navbar";

// Default hero image (adjust path to your project)
import heroFallback from "../assets/product3.webp";

export default function RecipePage({ productId }) {
  const normalizedId = productId != null ? String(productId) : "";

  // pick initial index by matching either recipe.id or recipe.productId
  const derivedInitialIndex = useMemo(() => {
    if (!normalizedId) return 0;
    const byRecipeId = recipes.findIndex((r) => String(r.id) === normalizedId);
    if (byRecipeId >= 0) return byRecipeId;
    const byProductId = recipes.findIndex(
      (r) => String(r.productId) === normalizedId
    );
    return byProductId >= 0 ? byProductId : 0;
  }, [normalizedId]);

  const [activeIdx, setActiveIdx] = useState(derivedInitialIndex);

  useEffect(() => {
    setActiveIdx(derivedInitialIndex);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [derivedInitialIndex]);

  const recipe = recipes[activeIdx];

  if (!recipe) {
    return (
      <>
        <NavBar textColor="#000" />
        <div className="pd-container">No recipes available.</div>
      </>
    );
  }

  // Use per-recipe hero if present; fallback otherwise
  const heroUrl = recipe.hero || heroFallback;

  return (
    <>
      <NavBar textColor="#000" />
      <div className="pd-container">
        {/* Category chip bar */}
        <nav className="pd-cats" aria-label="Recipe categories">
          <div className="pd-cats__wrap" role="tablist">
            {recipes.map((r, i) => (
              <a
                key={r.id}
                href="#"
                role="tab"
                aria-selected={i === activeIdx}
                tabIndex={0}
                className={`pd-cat ${i === activeIdx ? "is-active" : ""}`}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveIdx(i);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setActiveIdx(i);
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }
                }}
              >
                <span className="pd-cat__dot" aria-hidden="true" />
                <span className="pd-cat__label">{r.title}</span>
              </a>
            ))}
          </div>
        </nav>

        {/* Glassmorphic recipe card over a BACKGROUND IMAGE */}
        <section
          className="pd-hero pd-hero--recipe"
          style={{ backgroundImage: `url(${heroUrl})` }}
        >
          <div className="pd-hero__overlay" />
          <div className="pd-recipe-overlay">
            <h2>Recipe Highlight</h2>
            <h3>{(recipe.title || "").toUpperCase()}</h3>

            {recipe.description && (
              <p className="pd-recipe__desc">{recipe.description}</p>
            )}

            <div className="pd-recipe__lists">
              {Array.isArray(recipe.ingredients) &&
                recipe.ingredients.length > 0 && (
                  <div>
                    <h4>Ingredients</h4>
                    <ul>
                      {recipe.ingredients.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                )}

              {Array.isArray(recipe.instructions) &&
                recipe.instructions.length > 0 && (
                  <div>
                    <h4>Instructions</h4>
                    <ol>
                      {recipe.instructions.map((step, i) => (
                        <li key={i}>{step}</li>
                      ))}
                    </ol>
                  </div>
                )}
            </div>

            {recipe.quickTip && (
              <p className="pd-recipe__tip">
                <strong>Quick Tip:</strong> {recipe.quickTip}
              </p>
            )}

            {/* ✅ Now routes directly to /products */}
            <div className="pd-cta-wrap">
              <Link className="pd-cta" to="/products" aria-label="Browse all products">
                View Product →
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
